<form [formGroup]="myForm" (ngSubmit)="onSubmit()" autocomplete="off" novalidate>

  <h2 mat-dialog-title style="margin-bottom: 0px">{{title}}</h2>
  <mat-divider style="margin-bottom: 8px;"></mat-divider>

  <div >

          <mat-form-field>
            <mat-label>Account Name:</mat-label>
            <input matInput formControlName="name">
          </mat-form-field>

          <mat-form-field>
            <mat-label>Account Slug:</mat-label>
            <input matInput formControlName="slug">
            <mat-error>
              <strong>Alpha, no spaces, and lowercase only</strong>
          </mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Account Description:</mat-label>
            <input matInput formControlName="description">
          </mat-form-field>


          <mat-form-field class="mat-select-width">
            <mat-label>Time Zone</mat-label>
            <mat-select formControlName="time_zone" class="dude.mat-select-value">
              <mat-option *ngFor="let dt of timezone_list" [value]="dt.id">
                {{dt.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div mat-dialog-actions>
            <button mat-button type="button" (click)="dialogRef.close('cancel')" color="accent">Cancel</button>
            <!--<button mat-button (click)= "update()"   cdkFocusInitial>Create</button>-->
            <button mat-raised-button [disabled]="!myForm.valid" type="submit" color="primary">
              {{button_text}}
            </button>
          </div>

  </div>


</form>
